export default function (keyword, places = []) {
  return places.filter(place =>
    place.airportcode.includes(keyword.toUpperCase()) || 
    place.airportname.includes(keyword) || 
    place.cityname.includes(keyword) || 
    place.countryname.includes(keyword) || 
    place.name.includes(keyword)
  )
}
